<div class="container-fluid">
  <div class="bg-white mt-4">
    <form [formGroup]="notificationFormArrayForm" (ngSubmit)="submit()">
      <div class="vet-user-notification-setting-popup">



        <div class="modal-body " [ngClass]="{ 'w-50': !data?.userId }" style=" min-height: calc(100vh - 300px); ">
          <!--<div class="row mb-4">
            <div class="col-auto">
              <h4 class="">
                Notification Settings
                <i class="fa fa-spinner fa-spin" *ngIf="isLoading"></i>
              </h4>
            </div>

          </div>-->
          <div class="alert alert-warning" role="alert" *ngIf="contactsUnavailableMessage">
            <i class="fa fa-exclamation-triangle me-2"></i>{{ contactsUnavailableMessage }}
          </div>
          <div class="alert alert-info py-2 small" role="note" *ngIf="salesCompanyView && !contactsUnavailableMessage">
            <i class="fa fa-info-circle me-1"></i>
            You can add contacts for this vet. You can change or delete only the contacts your company added;
            the vet's own contacts are shown read only.
          </div>
          <!-- Email Section -->

          <div *ngIf="!contactsUnavailableMessage">
            <h5>Email Address(s)</h5>
            <table class="table table-borderless">
              <thead>
                <tr>
                  <th>Email</th>
                  <th class="text-center">Primary</th>
                  <th class="text-center">Notifications</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let formGroup of emailForms; let i = index;" [formGroup]="formGroup" class="align-items-center">
                  <td>
                    <div class="input-group " *ngIf="!isLocked(formGroup); else lockedEmail">
                      <span class="input-group-text bg-white" id="basic-addon1">
                        <i class="far fa-envelope-open"></i>
                      </span>
                      <input type="text" class="form-control" placeholder="Email" formControlName="email"
                             [ngClass]="{
                   'form-required-border': formGroup.get('email').invalid &&
                   (formGroup.get('email').dirty || formGroup.get('email').touched)
                 }">
                    </div>
                    <ng-template #lockedEmail>
                      <div class="form-control-plaintext">
                        <i class="far fa-envelope-open me-2"></i>{{ formGroup.get('email').value }}
                      </div>
                    </ng-template>
                    <ng-container *ngIf="!isLocked(formGroup)">
                    <span class="text-danger" *ngIf="formGroup.get('email').hasError('required') &&
                 (formGroup.get('email').dirty || formGroup.get('email').touched)">
                      Email is required
                    </span>
                    <span class="text-danger" *ngIf="formGroup.get('email').hasError('email')">
                      Please enter a valid email address
                    </span>
                    </ng-container>
                    <div *ngIf="salesCompanyView" class="mt-1">
                      <span class="badge bg-info text-dark" *ngIf="isOwnContact(formGroup)">Added by your company</span>
                      <span class="badge bg-light text-secondary border" *ngIf="isLocked(formGroup)"
                            title="Only the vet or their clinic admin can change this contact">
                        <i class="fa fa-lock me-1"></i>Vet's contact, read only
                      </span>
                    </div>
                  </td>
                  <td class="text-center">
                    <input type="radio" formControlName="isPrimaryEmail" (change)="onPrimaryEmailChange(i)" name="isPrimaryEmail" [value]="true"
                           [attr.disabled]="salesCompanyView ? true : null">

                  </td>
                  <td class="text-center">
                    <button type="button" class="btn btn-outline-primary" [disabled]="isLocked(formGroup) || !formGroup.get('email').value || formGroup.get('email').hasError('email')" (click)="openNotificationTypeModal(formGroup)">({{formGroup.controls.userNotificationType.length}}) {{ isLocked(formGroup) ? 'Types' : 'Edit' }}</button>
                    <button type="button" class="btn btn-outline-danger ms-1" *ngIf="!isLocked(formGroup)" (click)="removeNotificationContact(formGroup,true)"><i class="fa fa-trash"></i></button>
                  </td>
                </tr>
              </tbody>
            </table>
            <a href="javascript:void(0)" (click)="addEmail()" class="link-add">
              <span class="btn btn-primary btn-sm"><i class="fa fa-plus"></i></span>
              <span class="ms-1">Add Email</span>
            </a>
            <hr />
          </div>

          <!-- Mobile Section -->
          <div *ngIf="!contactsUnavailableMessage">
            <h5>Mobile(s)</h5>
            <table class="table table-borderless">
              <thead>
                <tr>
                  <th>Mobile</th>
                  <th class="text-center">Primary</th>
                  <th class="text-center">Notifications</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let formGroup of mobileForms; let i = index;" [formGroup]="formGroup" class="align-items-center">
                  <td>

                    <div class="form-control-plaintext" *ngIf="isLocked(formGroup)">
                      <i class="fas fa-phone me-2"></i>{{ formGroup.get('countryCode').value }} {{ formGroup.get('mobile').value }}
                    </div>
                    <div class="input-group " *ngIf="!isLocked(formGroup)">
                      <span class="input-group-text bg-white" id="basic-addon1">
                        <i class="fas fa-phone"></i>
                      </span>
                      <ngx-intl-tel-input [cssClass]="'form-control dropdown-up'"
                                          [preferredCountries]="preferredCountries"
                                          [enableAutoCountrySelect]="true"
                                          [enablePlaceholder]="true"
                                          [searchCountryFlag]="true"
                                          [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name, SearchCountryField.DialCode]"
                                          [selectedCountryISO]="selectedCountryISO"
                                          [maxLength]="15"
                                          [selectFirstCountry]="false"
                                          [separateDialCode]="true"
                                          [phoneValidation]="true"
                                          [numberFormat]="PhoneNumberFormat.National"
                                          formControlName="mobileNumberControl"
                                          name="mobile_{{i}}">
                      </ngx-intl-tel-input>
                    </div>
                    <span class="text-danger float-start w-100" *ngIf="formGroup.get('mobile').hasError('required') &&
                 (formGroup.get('mobile').dirty || formGroup.get('mobile').touched)">
                      Mobile number is required
                    </span>
                    <span class="text-danger float-start w-100" *ngIf="formGroup.get('mobile').hasError('pattern')">
                      Please enter a valid mobile number
                    </span>
                    <div *ngIf="salesCompanyView" class="mt-1 float-start w-100">
                      <span class="badge bg-info text-dark" *ngIf="isOwnContact(formGroup)">Added by your company</span>
                      <span class="badge bg-light text-secondary border" *ngIf="isLocked(formGroup)"
                            title="Only the vet or their clinic admin can change this contact">
                        <i class="fa fa-lock me-1"></i>Vet's contact, read only
                      </span>
                    </div>
                  </td>
                  <td class="text-center">
                    <input type="radio" formControlName="isPrimaryMobile" (change)="onPrimaryMobileChange(i)" name="isPrimaryMobile" [value]="true"
                           [attr.disabled]="salesCompanyView ? true : null">

                  </td>
                  <td class="text-center">
                    <button type="button" class="btn btn-outline-primary" [disabled]="isLocked(formGroup) || !formGroup.get('mobileNumberControl')?.valid" (click)="openNotificationTypeModal(formGroup)">({{formGroup.controls.userNotificationType.length}}) {{ isLocked(formGroup) ? 'Types' : 'Edit' }}</button>
                    <button type="button" class="btn btn-outline-danger ms-1" *ngIf="!isLocked(formGroup)" (click)="removeNotificationContact(formGroup,false)"><i class="fa fa-trash"></i></button>
                  </td>
                </tr>
              </tbody>
            </table>
            <a href="javascript:void(0)" (click)="addMobile()" class="link-add">
              <span class="btn btn-primary btn-sm"><i class="fa fa-plus"></i></span>
              <span class="ms-1">Add Mobile</span>
            </a>
          </div>



          <button type="submit" class="btn btn-primary btn-sm float-end" [disabled]="!isFormValid()" *ngIf="isUseBuiltInSave">
            <i class="fa fa-spinner fa-spin" *ngIf="isSubmitLoading"></i>
            <i class="fa fa-save" *ngIf="!isSubmitLoading"></i> Save
          </button>
          <button type="button" class="btn btn-secondary btn-sm float-end me-2" (click)="cancel()" *ngIf="isUseBuiltInSave"><i class="fa fa-times"></i> Cancel</button>
        </div>

      </div>
    </form>
  </div>
</div>
